import * as React from "react";
const PersonalCareSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M28.791 17.633a3.043 3.043 0 0 0-2.326-.597C28.813 14.666 30 12.31 30 10c0-3.309-2.661-6-5.933-6A5.947 5.947 0 0 0 19.5 6.094 5.947 5.947 0 0 0 14.932 4C11.662 4 9 6.691 9 10c0 1.375.405 2.711 1.258 4.125a3.984 3.984 0 0 0-1.844 1.05L5.586 18H2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h13c.082 0 .163-.01.242-.03l8-2a.868.868 0 0 0 .15-.05l4.858-2.067.055-.025a3.075 3.075 0 0 0 .491-5.195h-.005ZM14.932 6a3.894 3.894 0 0 1 3.643 2.375 1 1 0 0 0 1.85 0A3.894 3.894 0 0 1 24.067 6C26.2 6 28 7.831 28 10c0 2.439-1.974 5.198-5.707 7.988l-1.387.318A3.5 3.5 0 0 0 17.5 14h-4.915C11.506 12.545 11 11.265 11 10c0-2.169 1.801-4 3.932-4ZM2 20h3v5H2v-5Zm25.429 1.026-4.75 2.023L14.875 25H7v-5.586l2.829-2.828A1.983 1.983 0 0 1 11.242 16H17.5a1.5 1.5 0 0 1 0 3H14a1 1 0 0 0 0 2h4c.075 0 .15-.009.224-.025l8.375-1.926.038-.01a1.075 1.075 0 0 1 .788 1.987h.004Z"
    />
  </svg>
);
export default PersonalCareSVG;
